module.exports = "<app-report-modal2 [commonData] = 'gridData' [report]='reportName'></app-report-modal2>"